module.exports = __webpack_public_path__ + "img/7.ccb5ec92.png";